import React, { useState } from "react";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../../services/global-services";
import { permShifts } from "../checksPermmision";
import CheckboxItems, { useStylesAccs } from "../CheckBoxComponents";

export default function ShiftsPermission(props) {
    const { onChange, object, accounts } = props;
    const accs = accounts.filter((obj) => parseFloat(obj.id)> 1234);
    const [Accounts, setAccounts] = useState(() => {
        return [{ id: -1, name: "no" }, ...accs];
    });
    const valueCloseAcc = GetItemFromOptions(object?.shift_trans_close_acc_no ?? -1, Accounts);
    const valuePlusAcc = GetItemFromOptions(object?.shift_trans_plus_acc_no ?? -1, Accounts);
    const valueMinAcc = GetItemFromOptions(object?.shift_trans_minus_acc_no ?? -1, Accounts);

    const getoptionCustomers = (option) => {
        return `${option?.name + '  ' + option?.id ?? ""}`
      };
    
    const classes = useStylesAccs();

    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <AccordionDetails>
                    <Grid item container spacing={1}>
                        {permShifts
                            ?.filter((d) => d.visible)
                            ?.map((item) => {
                                return (
                                    <Grid xs={6}>
                                        <CheckboxItems
                                            value={object[item.name] ?? null}
                                            name={item.name}
                                            label={item.label}
                                            onChange={onChange}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                </AccordionDetails>
                <Grid container lg={12} md={12} sm={12} xs={12} spacing={1}>
                    <Grid item lg={2} md={2} sm={6} xs={6} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{"حساب صندوق الترحيل"}</div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={6} >
                        <Autocomplete
                            value={valueCloseAcc}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "shift_trans_close_acc_no",
                                    value: newValue?.id,
                                });
                            }}
                            id="apply_discount"
                            size="small"
                            options={Accounts}
                            getOptionLabel={(option) =>
                                getoptionCustomers(option)
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="حساب صندوق الترحيل "
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{"الحساب الذي سيتم ترحيل المبلغ اليه من صندوق الموظف"}</div>
                    </Grid>
                    <Grid item lg={2} md={2} sm={6} xs={6} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{"حساب الفائض"}</div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={6} >
                        <Autocomplete
                            value={valuePlusAcc}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "shift_trans_plus_acc_no",
                                    value: newValue?.id,
                                });
                            }}
                            id="shift_trans_plus_acc_no"
                            size="small"
                            options={Accounts}
                            getOptionLabel={(option) =>
                                getoptionCustomers(option)
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="حساب الفائض"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{"الحساب الذي سيتم ترحيل المبلغ اليه في حال الزيادة"}</div>
                    </Grid>
                    <Grid item lg={2} md={2} sm={6} xs={6} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{"حساب العجز"}</div>
                    </Grid>
                    <Grid item  lg={4} md={4} sm={6} xs={6}>
                        <Autocomplete
                            value={valueMinAcc}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "shift_trans_minus_acc_no",
                                    value: newValue?.id,
                                });
                            }}
                            id="shift_trans_minus_acc_no"
                            size="small"
                            options={Accounts}
                            getOptionLabel={(option) =>
                                getoptionCustomers(option)
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="حساب العجز"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{"الحساب الذي سيتم ترحيل المبلغ اليه في حال النقصان"}</div>
                    </Grid>
                </Grid>
            </Accordion>
            <Swipeable />
        </div>
    );
}
